(function(){
  'use strict';
  var root = document.getElementById('bbb-pdp');
  if (!root) return;

  // reveal on scroll
  var revs = root.querySelectorAll('.bbb-pdp-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('vis'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    revs.forEach(function(r){ io.observe(r); });
  } else { revs.forEach(function(r){ r.classList.add('vis'); }); }

  // hero carousel
  var slides = root.querySelectorAll('.bbb-pdp-hero__slide');
  var dots = root.querySelectorAll('.bbb-pdp-hero__dot');
  var idx = 0, n = slides.length, timer;
  function go(i){
    idx = (i + n) % n;
    slides.forEach(function(s,k){ s.classList.toggle('on', k===idx); });
    dots.forEach(function(d,k){ d.classList.toggle('on', k===idx); });
  }
  function loop(){ timer = setInterval(function(){ go(idx+1); }, 4200); }
  dots.forEach(function(d){
    d.addEventListener('click', function(){
      clearInterval(timer);
      go(+d.dataset.go);
      loop();
    });
  });
  if (n > 1) loop();

  // inside-pages flipper (two-page spreads)
  var spreads = root.querySelectorAll('.bbb-pdp-pages__spread');
  var pdots = root.querySelectorAll('.bbb-pdp-pages__dot');
  var prevBtn = root.querySelector('.bbb-pdp-pages__nav--prev');
  var nextBtn = root.querySelector('.bbb-pdp-pages__nav--next');
  var pageBook = root.querySelector('.bbb-pdp-pages__book');
  if (spreads.length > 0){
    var sIdx = 0, sN = spreads.length, animating = false;
    function setSpread(i){
      if (animating) return;
      var target = (i + sN) % sN;
      if (target === sIdx) return;
      animating = true;
      var current = spreads[sIdx];
      current.classList.add('leaving');
      current.classList.remove('on');
      setTimeout(function(){
        current.classList.remove('leaving');
        spreads[target].classList.add('on');
        pdots.forEach(function(d,k){ d.classList.toggle('on', k===target); });
        sIdx = target;
        animating = false;
      }, 420);
    }
    if (prevBtn) prevBtn.addEventListener('click', function(){ setSpread(sIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ setSpread(sIdx + 1); });
    pdots.forEach(function(d){
      d.addEventListener('click', function(){ setSpread(+d.dataset.leafGo); });
    });
    document.addEventListener('keydown', function(e){
      if (!pageBook) return;
      var rect = pageBook.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (!inView) return;
      if (e.key === 'ArrowLeft') setSpread(sIdx - 1);
      else if (e.key === 'ArrowRight') setSpread(sIdx + 1);
    });
    if (pageBook){
      var sx = 0, sy = 0;
      pageBook.addEventListener('touchstart', function(e){
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      pageBook.addEventListener('touchend', function(e){
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSpread(sIdx + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }
  }

  // sticky bar reveal past hero
  var hero = root.querySelector('.bbb-pdp-hero');
  var sticky = root.querySelector('.bbb-pdp-sticky');
  if (hero && sticky && 'IntersectionObserver' in window){
    var so = new IntersectionObserver(function(es){
      es.forEach(function(e){ sticky.classList.toggle('vis', !e.isIntersecting); });
    }, { threshold: 0.05 });
    so.observe(hero);
  }
})();
